import React,{ useState, useEffect } from 'react';
import { useSelector,  connect} from 'react-redux';
import { Divider, Button, Modal } from 'rsuite';
import * as actionsPolicy  from '../../../../app/actions/policy';
import {validateMappedRegValuesFull} from '../../../../app/common/services/vehicle.service';
import NuInsStepper from '../elements/NuInsStepper';
import {NuInsSelectLabel} from '../elements/inputFieldsLabel';
import {CheckBoxCustom} from '../elements/inputFields';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import {FrameIcon} from '../svg/iconFrameSvg';
import {mpsTypes, mpsDesignation, regPropsBG} from '../../../../app/common/types/vehicleTypes';
import CustomDrawer from '../../../pages/components/elements/CustomDrawer';

const optionMpsTypes = Object.keys(mpsTypes).map(key => ({label: mpsTypes[key], value: key, role: "Master"})) 
const optionDesignation = Object.keys(mpsDesignation).map(key => ({label: mpsDesignation[key], value: key, role: "Master"})) 

// --------------------------------------------------------------------------------------------

const QuestionnaireVehicle = ({onBack, onForward, updateQuestionsPolicy, style}) => {
    const insVehicleInfo = useSelector(state => state.insVehicleInfo);
    const {registrationProps, location, initialData} = insVehicleInfo;
    const {locationCode, districtName} = location || {};
    const {registered} = initialData || {};

    const questions = useSelector(state => state.questionsPolicy);
    const {vehicleType, vehicleUsage, isRightWheelDrive, moreThan60DaysAbroad, isDriverForeigner } = questions;

    const insCompanies = useSelector(state => state.insCompanies);

    const [showDrawer, setShowDrawer] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showMissingModal, setShowMissingModal] = useState(false);

    const changeHandler = (field, data) => {
       // console.log(questions, field)
        switch (field) {
            case 'vehicleType':
                return updateQuestionsPolicy({vehicleType: data});
            case 'vehicleUsage':
                return updateQuestionsPolicy({vehicleUsage: data});
            case 'isRightWheelDrive':
                return updateQuestionsPolicy({isRightWheelDrive: data ? '1' : '0'});
            case 'moreThan60DaysAbroad':
                return updateQuestionsPolicy({moreThan60DaysAbroad: data ? '1' : '0'});
            case 'isDriverForeigner':
                return updateQuestionsPolicy({isDriverForeigner: data ? '1' : '0'});
            default:
                return 'Unknown stepIndex';
        }
    }

    const submitHandler = () => {
        const dataToUpdate = { isRightWheelDrive    : isRightWheelDrive    ? isRightWheelDrive    : '0', 
                               moreThan60DaysAbroad : moreThan60DaysAbroad ? moreThan60DaysAbroad : '0',
                               isDriverForeigner    : isDriverForeigner    ? isDriverForeigner    : '0' }
        
        updateQuestionsPolicy(dataToUpdate);

        if(!registered) {
           return onForward(3);
        }

        setSubmitted(true);
    }

    const validateFields = () => {
        return vehicleType && vehicleUsage;
    }

    const goBack = () => {
        onBack(1);
    }

    const closeDrawer = () => {
        setShowDrawer(false);
    }

    const openDrawer = (event) => {
        event.stopPropagation();
        setShowDrawer(true);
    }

    useEffect(() => {
        if(questions?.generalRegistrationType === undefined) {
            if(registered) {
                updateQuestionsPolicy({...questions, generalRegistrationType: 0});
            } else { 
                updateQuestionsPolicy({...questions, generalRegistrationType: 2});
            }
        }
    }, [registered, updateQuestionsPolicy, questions])

    useEffect(() => {
        const type = registrationProps?.vehicleType?.value ? registrationProps?.vehicleType?.value : '1';

        if(vehicleType === undefined) updateQuestionsPolicy({...questions, vehicleType: type});
        if(vehicleUsage === undefined) updateQuestionsPolicy({...questions, vehicleUsage: '1'});

     //   console.log('vehicleType', vehicleType)

    },[questions, vehicleType, vehicleUsage, registrationProps, updateQuestionsPolicy]);

    useEffect(() => {
    //    console.log('submitted', submitted, registrationProps, locationCode, insCompanies)
        if(submitted && registrationProps && !registrationProps.messageCode && (locationCode || districtName) && insCompanies.length) {
            if(registered && validateMappedRegValuesFull(registrationProps, vehicleType)) {
                onForward(4);
            }  else if(registrationProps && Object.keys(registrationProps).length) {
                if(!showMissingModal) updateQuestionsPolicy({...questions, generalRegistrationType: 3});
                
                setShowMissingModal(true);
            }
        }
    },[submitted, insCompanies.length, locationCode, districtName, registrationProps, questions, updateQuestionsPolicy, showMissingModal, vehicleType, registered, onForward]);

    const goToMissingData = () => {
        setSubmitted(false);
        setShowMissingModal(false);
        onForward(3);
    }

    const cancelMissinData = () => {
        setSubmitted(false);
        setShowMissingModal(false);
    }

    const setBooleanValue = (value) => {
        if(!value) return false;
        return value === '1' ? true : false;
    }

    const renderTalonData = () => {
        if(!registrationProps || !Object.keys(registrationProps).length) return null;

        return Object.keys(registrationProps).reduce((acc, key, i) => {
            if(Object.keys(regPropsBG).includes(key)) {
                const addedtext = (key === 'maxPower') ? 'kW' : (key === 'engineCapacity') ? 'куб.см' : null;

                return [...acc, <div className="custom-drawer-data" key={i}>{[regPropsBG[key]]}: <span className="bold">{registrationProps[key].userValue} <span>{addedtext}</span></span></div> ]
            }

            return acc;
        }, [])
    }

    const errorMsg = "Полето е задължително";

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={1} steps={4} labels={steppLabels}/>              
            </div>
            <Divider />
            <div className="big-icon-container">
                <FrameIcon />
            </div>
            
            <NuInsSelectLabel placeholder={"Вид МПС"} options={optionMpsTypes} value={vehicleType || registrationProps?.vehicleType?.value} 
                              onChange={(data) => changeHandler('vehicleType', data)} error={false} errorMsg={errorMsg}/>
            <div  style={{marginBottom: '18px'}}></div>
            <NuInsSelectLabel placeholder={"Предназначение"} options={optionDesignation} value={vehicleUsage } 
                              onChange={(data) => changeHandler('vehicleUsage', data)} error={false} errorMsg={errorMsg}/>
            
            <div className="steps_container-checkbox" style={{marginBottom: '18px', marginTop: '18px'}}>
                    <CheckBoxCustom onChange={(data) => changeHandler('isRightWheelDrive', data)} value={setBooleanValue(questions?.isRightWheelDrive)}/>
                    <div>Десен волан</div>
            </div>
         
            <div className="steps_container-checkbox" style={{marginBottom: '18px'}}>
                    <CheckBoxCustom onChange={(data) => changeHandler('moreThan60DaysAbroad', data)} value={setBooleanValue(questions?.moreThan60DaysAbroad)}/>
                    <div>Ползване повече от 60 дни в чужбина</div>
            </div>
        
            <div className="steps_container-checkbox" style={{marginBottom: '18px'}}>
                    <CheckBoxCustom onChange={(data) => changeHandler('isDriverForeigner', data)} value={setBooleanValue(questions?.isDriverForeigner)}/>
                    <div>Ползване от чужденец</div>
            </div>
         
            { (initialData?.registered && registrationProps)
                ? <Button appearance="link" onClick={openDrawer}>Покажи данни от талона</Button>
                : null }            

            <button className="nuIns-btn nuIns-btn-main" type="submit" style={{marginTop: '18px', marginBottom: '54px'}}
                    onClick={submitHandler}
                    disabled={!validateFields()}
                    >Продължи</button>

            <CustomDrawer show={showDrawer} close={closeDrawer} headerText="Данни на МПС от талон">
                {renderTalonData()}
            </CustomDrawer>
  
            <Modal size="xs" show={showMissingModal} className="nuins-ok-modal" onHide={() => cancelMissinData()}>
                <Modal.Body>
                    <p className="no-reg-data">В регистъра не са намерени всички данни, въведи липсващите данни</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => goToMissingData()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )

}

export default connect(null, {...actionsPolicy})(QuestionnaireVehicle);